import { initializeDefaultParameterStructure } from "../model/DefaultParametersInitializer";
import { IAction } from "../model/IAction";
import { IParameterSchema } from "../model/IProcessData";

export const ADD_ARRAY_ELEMENT = "ADD_ARRAY_ELEMENT";
export function addArrayElement(elementId: string, key: string, parameterTemplate: IParameterSchema): AddArrayElementAction {
  const defaultParameters = initializeDefaultParameterStructure(parameterTemplate, null);
  return {
    type: ADD_ARRAY_ELEMENT,
    elementId: elementId,
    key: key,
    defaultParameters: defaultParameters
  };
}
export interface AddArrayElementAction extends IAction {
  elementId: string;
  key: string;
  defaultParameters: any;
}
